const navLinks = [
  {
    name: "Projets",
    link: "#projets",
    iconPath: "/images/icons/projects.png",
  },
  {
    name: "Services",
    link: "#services",
    iconPath: "/images/icons/services.png",
  },
  {
    name: "Qui suis-je ?",
    link: "#about",
    iconPath: "/images/icons/about.png",
  },
  {
    name: "Expérience",
    link: "#experience",
    iconPath: "/images/icons/experience.png",
  },
  {
    name: "Compétences",
    link: "#skills",
    iconPath: "/images/icons/skills.png",
  },
];

const words = [
  { text: "Idées", imgPath: "/images/ideas.svg" },
  { text: "Concepts", imgPath: "/images/concepts.svg" },
  { text: "Interfaces", imgPath: "/images/designs.svg" },
  { text: "Envies", imgPath: "/images/code.svg" },
  { text: "Idées", imgPath: "/images/ideas.svg" },
  { text: "Concepts", imgPath: "/images/concepts.svg" },
  { text: "Interfaces", imgPath: "/images/designs.svg" },
  { text: "Envies", imgPath: "/images/code.svg" },
];

const logoIconsList = [
  {
    imgPath: "/images/logos/company-logo-1.png",
  },
  {
    imgPath: "/images/logos/company-logo-2.png",
  },
  {
    imgPath: "/images/logos/company-logo-3.jpeg",
  },
  {
    imgPath: "/images/logos/company-logo-4.png",
  },
  {
    imgPath: "/images/logos/company-logo-5.png",
  },
  {
    imgPath: "/images/logos/company-logo-6.png",
  },
  {
    imgPath: "/images/logos/company-logo-7.png",
  },
];

const abilities = [
  {
    imgPath: "/images/picto1.png",
    title: "Audit de site web",
    desc: "Analyse complète de la performance, du responsive, de l'accessibilité et du SEO pour identifier les points à optimiser.",
  },
  {
    imgPath: "/images/picto2.png",
    title: "Développement sur mesure",
    desc: "Création de sites web interactifs, animés et ultra-performants, parfaitement adaptés à vos besoins et votre image de marque.",
  },
  {
    imgPath: "/images/picto3.png",
    title: "Optimisation & SEO",
    desc: "Modernisation de votre site existant pour améliorer l'expérience utilisateur, la vitesse de chargement et le référencement naturel.",
  },
];


const techStackImgs = [
  {
    name: "Frontend / React",
    imgPath: "/images/logos/react.png",
  },
  {
    name: "Animation GSAP",
    imgPath: "/images/logos/gsap.svg",
  },
  {
    name: "Backend NodeJS",
    imgPath: "/images/logos/node.png",
  },
  {
    name: "Intéraction & 3D",
    imgPath: "/images/logos/three.png",
  },
  {
    name: "Github",
    imgPath: "/images/logos/git.svg",
  },
];
const techStackIcons = [
  {
    name: "Frontend / React",
    modelPath: "/models/react_logo-transformed.glb",
    scale: 1,
    rotation: [0, 0, 0],
  },
  {
    name: "Animation GSAP",
    modelPath: "https://my.spline.design/3dpathshandwrittencopy-iq5jVQaxknVShu0HfZrzL8zG/",
    scale: 0.8,
    rotation: [0, 0, 0],
  },
  {
    name: "Backend NodeJS",
    modelPath: "/models/node-transformed.glb",
    scale: 5,
    rotation: [0, -Math.PI / 2, 0],
  },
  {
    name: "Intéraction & 3D",
    modelPath: "/models/three.js-transformed.glb",
    scale: 0.05,
    rotation: [0, 0, 0],
  },
  {
    name: "Github",
    modelPath: "/models/git-svg-transformed.glb",
    scale: 0.05,
    rotation: [0, -Math.PI / 4, 0],
  },
];

const expCards = [
  {
    review:
      "Se lancer en freelance, c’est sortir du cadre pour confronter ses compétences au terrain. Chaque projet est un challenge réel, avec un impact immédiat.",
    imgPath: "/images/exp1.png",
    logoPath: "/images/logo1.png",
    title: "Développeur Web Freelance",
    date: "Aujourd'hui",
    responsibilities: [
      "Création de sites vitrines sur mesure pour des indépendants et TPE.",
      "Développement avec Laravel, Tailwind CSS, React et ThreeJS selon les besoins clients.",
      "Optimisation SEO, responsive design et performances web (EcoIndex, Lighthouse).",
    ],
  },
  {
    review:
      "2 ans d’alternance, c’est comme 2 ans d'accélération : j’ai appris à livrer, à collaborer, à rattraper des bugs à 18h et à proposer des vraies solutions utiles.",
    imgPath: "/images/exp2.png",
    logoPath: "/images/logo2.png",
    title: "Alternance WebMaster – Maison Cadiou",
    date: "2023 - 2025",
    responsibilities: [
      "Développement du site Majuskule en Laravel (front & back-office Filament).",
      "Mise en place de visualisations 3D, contenus multilingues et stratégie SEO.",
      "Refontes graphiques de sites internes avec animations JS (GSAP, Tailwind).",
    ],
  },
  {
    review:
      "Ces années à l’IUT m’ont permis de poser des bases solides : code propre, rigueur, travail en équipe… mais aussi une vraie envie d’aller plus loin par moi-même.",
    imgPath: "/images/exp3.png",
    logoPath: "/images/logo3.png",
    title: "BUT Informatique – IUT de Vannes",
    date: "2021 - 2025",
    responsibilities: [
      "Apprentissage du développement web full stack (Laravel, JS, React).",
      "Travaux en projet agile : API, base de données, sécurité, UI/UX.",
      "Développement de projets IA, optimisation d’algorithmes, et micro-services.",
    ],
  },
];


const expLogos = [
  {
    name: "logo1",
    imgPath: "/images/logo1.png",
  },
  {
    name: "logo2",
    imgPath: "/images/logo2.png",
  },
  {
    name: "logo3",
    imgPath: "/images/logo3.png",
  },
];

const socialImgs = [
  {
    name: "linkedin",
    imgPath: "/images/linkedin.png",
    link: "https://www.linkedin.com/in/goulven-ronarch/",
  },
];

export {
  words,
  abilities,
  logoIconsList,
  expCards,
  expLogos,
  socialImgs,
  techStackIcons,
  techStackImgs,
  navLinks,
};